class PincodeChecker extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector("button");
    this.input = this.querySelector("input");
    this.failureNode = this.querySelector("[data-pincode-failure]");
    this.inValidCode = this.querySelector("[data-validate-failure]");
    this.success = this.querySelector("[data-success-text]");

    // Disabling the ATC and Buy now button by default.
    this.disableAddButton(true);

    // Check if data is already available in local storage, if yes, then use it.
    // Otherwise fetch the data from google sheets.
    this.data =
      JSON.parse(sessionStorage.getItem("pincodeSheetData")) ||
      this.fetchSheetsData();

    this.reuseSessionStorageData();
    this.button.addEventListener("click", (evt) =>
      this.checkPincodeAvailability(evt)
    );
    document.querySelectorAll(".header-pincode").forEach((each) => {
      each.addEventListener("click", () => {
        this.openAndCloseMobilePincodeDrawer();
        if (this.getAttribute("submited-product")) {
          this.removeAttribute("submited-product");
        }
        this.input.value = "";
      });
    });

    document
      .querySelector("#pincode-checker-ele .pincode-empty")
      .addEventListener("click", () => {
        this.openAndCloseMobilePincodeDrawer();
        if (this.getAttribute("submited-product")) {
          this.removeAttribute("submited-product");
        }
        this.input.value = "";
      });

    //this will allow use to enter the numbers only
    this.querySelector("input").addEventListener("input", (event) => {
      this.querySelectorAll("p").forEach((elem) =>
        elem.classList.add("hidden")
      );
      let inputValue = event.target.value;

      // Remove any non-numeric characters using a regular expression
      const numericValue = inputValue.replace(/[^0-9]/g, "");

      // Limit the input value to a maximum length of 6 characters
      if (numericValue.length > 6) {
        inputValue = numericValue.substring(0, 6);
      } else {
        inputValue = numericValue;
      }

      // Set the input value to the truncated value
      event.target.value = inputValue;
    });
  }

  openAndCloseMobilePincodeDrawer() {
    if (window.innerWidth < 990) {
      this.classList.toggle("active-pincode");
      document.querySelector(".pincode-open svg").classList.add("rotated");
    }
    if (window.innerWidth > 989) {
      const parentElement = document.querySelector(
        "#pincode-checker-ele .header-pincode-container"
      );
      parentElement.classList.toggle("desktop-pincode-popup");
      document
        .querySelector(".header__icons .header-pincode")
        .classList.toggle("d-none");
    }
    this.querySelectorAll("p").forEach((elem) => elem.classList.add("hidden"));
    this.input.vlaue = "";
  }

  addProuductToCart(evt) {
    //this will initiate add to cart and closes the pincode
    if (
      this.getAttribute("submited-product") &&
      this.getAttribute("target") === "null"
    ) {
      this.submiteProduct = this.getAttribute("submited-product");
      document
        .querySelector(`[pid="${this.submiteProduct}"]`)
        .onSubmitHandler(evt);
      this.debounePincode();
    }

    if (
      this.getAttribute("submited-product") &&
      this.getAttribute("target") != "null"
    ) {
      this.submiteProduct = this.getAttribute("submited-product");
      const targetName = this.getAttribute("target");
      const targetElement =
        document
          .querySelector(`marmeto-product-card [pid="${this.submiteProduct}"]`)
          ?.querySelector("quantity-input") ||
        document
          .querySelector(
            `main-product-button[data-pid="${this.submiteProduct}"]`
          )
          ?.querySelector("quantity-input");
      if (targetElement) {
        const targetInput = targetElement.querySelector("input");
        targetName === "plus" ? targetInput.stepUp() : targetInput.stepDown();
        targetElement.updateProductQunatity(targetInput.value);
      }
      this.debounePincode();
    }

    if (this.getAttribute("ischeckout")) {
      this.checkoutClicked = this.getAttribute("isCheckout");
      const url = `${window.location.protocol}//${window.location.host}/checkout`;

      window.location.href = url;
    }
  }

  debounePincode = debounce(() => {
    this.openAndCloseMobilePincodeDrawer();
  }, 1000);

  async checkPincodeAvailability(evt) {
    const productPincode = document.querySelector("product-pincode");
    const prouductInput = this.querySelector("pincode-checker input");
    if (productPincode) {
      productPincode
        .querySelectorAll("p")
        .forEach((each) => each.classList.add("hidden"));
    }
    const pincode = this.input.value.trim();
    this.querySelectorAll("p").forEach((elem) => elem.classList.add("hidden"));
    // Validate the pincode
    if (!pincode || pincode.length !== 6 || isNaN(pincode)) {
      this.inValidCode.classList.remove("hidden");
      localStorage.removeItem("pincode");
      document.querySelector("#selected-pincode").textContent = "pincode";
      if (productPincode) {
        document
          .querySelector("[product-pincode-inValid]")
          .classList.remove("hidden");
        prouductInput.value = pincode;
      }
      return;
    }

    try {
      const [header, result] = await this.filterDataFromGoogleSheet(pincode);

      if (result) {
        localStorage.setItem("pincode", pincode);
        this.addProuductToCart(evt);
        // Enabling the ATC and Buy now button.
        this.disableAddButton(false);
        document.querySelector("#selected-pincode").textContent = pincode;
        this.success.classList.remove("hidden");
        if (this.submiteProduct) this.removeAttribute("submited-product");
        if (this.checkoutClicked) this.removeAttribute("isCheckout");

        if (productPincode) {
          document
            .querySelector("[product-pincode-available]")
            .classList.remove("hidden");
          if (result[2] !== undefined && result[2] !== "") {
            document.querySelector("[delivery-time-estimation]").textContent =
              " " + result[2];
          }
          document
            .querySelector("[delivery-time-estimation]")
            .classList.remove("hidden");
          prouductInput.value = pincode;
          if (document.querySelector("product-pincode input")) {
            document.querySelector("product-pincode input").value = pincode;
          }
        }
      } else {
        this.failureNode.classList.remove("hidden");
        localStorage.removeItem("pincode");
        document.querySelector("#selected-pincode").textContent = "pincode";
        if (pincode) {
          document
            .querySelector("[product-pincode-unavailable]")
            ?.classList.remove("hidden");
          prouductInput.value = pincode;
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  async filterDataFromGoogleSheet(pincode) {
    this.data = await this.fetchSheetsData();
    const rows = this.data.values;
    const [header, ...dataRows] = rows;
    const result = dataRows.find((row) => row[0] === pincode);
    return [header, result];
  }

  fetchSheetsData() {
    if (this.data) return this.data;

    const API_KEY = "AIzaSyDqBDc-OkoKDdI2poUEWgu-GKCVfMgw_L0";
    const SPREADSHEET_ID = "1g3Q1o8Q4VWt9jFBGftXXnpSjWjejrJJuIDnITHlV8i4";
    const RANGE = "Sheet1";
    const BASE_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${RANGE}`;
    const queryString = `?key=${API_KEY}&majorDimension=ROWS&valueRenderOption=FORMATTED_VALUE&dateTimeRenderOption=FORMATTED_STRING`;

    const url = `${BASE_URL}${queryString}`;
    return fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // Store the data in local storage
        sessionStorage.setItem("pincodeSheetData", JSON.stringify(data));
        return data;
      })
      .catch((error) => console.error(error));
  }

  reuseSessionStorageData() {
    if (!localStorage.getItem("pincode")) return;
    this.input.value = localStorage.getItem("pincode");
    this.checkPincodeAvailability();
  }

  disableAddButton(disable) {
    document
      .querySelector("variant-radios")
      ?.toggleAddButton(disable, "Add pincode");
    document
      .querySelector("variant-selects")
      ?.toggleAddButton(disable, "Add pincode");
    document
      .querySelectorAll('form[action="/cart/add"] button')
      .forEach((button) => {
        if (disable) button.setAttribute("pincode-valid", false);
        else button.removeAttribute("pincode-valid");
      });
  }
}

customElements.define("pincode-checker", PincodeChecker);

document.querySelector(".pincode-open").addEventListener("click", () => {
  document.querySelector("pincode-checker").openAndCloseMobilePincodeDrawer();
});

document.querySelector(".pincode-close").addEventListener("click", () => {
  let addButton = sessionStorage.getItem("productToCart");
  if (addButton) {
  }
  document.querySelector("pincode-checker").classList.remove("active-pincode");
  document.querySelector(".pincode-open svg").classList.remove("rotated");
});

//pincode checker on product page

class ProductPincode extends HTMLElement {
  constructor() {
    super();
    this.data =
      JSON.parse(sessionStorage.getItem("pincodeSheetData")) ||
      document.querySelector("pincode-checker").fetchSheetsData();

    this.querySelector("input").addEventListener("input", (event) => {
      this.querySelectorAll("p").forEach((elem) =>
        elem.classList.add("hidden")
      );
      const inputValue = event.target.value;

      // Remove any non-numeric characters using a regular expression
      const numericValue = inputValue.replace(/[^0-9]/g, "");

      // Set the input value to the numeric value
      event.target.value = numericValue;
    });
    this.input = this.querySelector("input");
    this.success = this.querySelector("[product-pincode-available]");
    this.failureNode = this.querySelector("[product-pincode-unavailable]");
    this.inValidCode = this.querySelector("[product-pincode-inValid]");
    this.estimation = this.querySelector("[delivery-time-estimation]");

    this.querySelector("button").addEventListener("click", () => {
      this.checkPincodeAvailability();
    });

    const savedPincode = localStorage.getItem("pincode");
    if (savedPincode) {
      this.input.value = savedPincode;
      this.checkPincodeAvailability(savedPincode);
    }
  }
  async checkPincodeAvailability(savedPincode) {
    const pincode = this.input.value.trim() || savedPincode;
    this.querySelectorAll("p").forEach((elem) => elem.classList.add("hidden"));

    // Validate the pincode
    if (!pincode || pincode.length !== 6 || isNaN(pincode)) {
      this.inValidCode.classList.remove("hidden");
      localStorage.removeItem("pincode");
      document.querySelector("#selected-pincode").textContent = "pincode";
      return;
    }

    try {
      const [header, result] = await document
        .querySelector("pincode-checker")
        .filterDataFromGoogleSheet(pincode);

      if (result) {
        localStorage.setItem("pincode", pincode);

        document.querySelector("#selected-pincode").textContent = pincode;

        if (result[2] !== undefined && result[2] !== "") {
          this.success.classList.remove("hidden");
          this.estimation.textContent = " " + result[2];
        }
      } else {
        this.failureNode.classList.remove("hidden");
        localStorage.removeItem("pincode");
        document.querySelector("#selected-pincode").textContent = "pincode";
      }
    } catch (error) {
      console.error(error);
    }
  }
}
customElements.define("product-pincode", ProductPincode);
